import { useEffect } from 'react';
import { useStore } from '../../../../hooks/useStore';
import { useCardOffer } from '../../../../queries/pxtraCard';
import { useCreateBenefitSet } from './useCreateBenefitSet';

/** Seeds the panel with the stored offer of the set being edited. The store
 * decides whether a refetch may still change it, so the user's edits stay. */
export const useSeedCardOffer = (enabled: boolean) => {
  const { companyStore } = useStore();
  const { newBenefitSet } = useCreateBenefitSet();
  const benefitSetId = newBenefitSet.editingBenefitSetId;
  const { data } = useCardOffer(companyStore.company?.id ?? '', benefitSetId, { enabled });

  useEffect(() => {
    if (!enabled || !data || !benefitSetId) return;

    newBenefitSet.loadCardOffer(benefitSetId, data.offer, data.setKnown);
  }, [enabled, data, benefitSetId]);
};
